import { useNavigate } from "react-router";
import { signOut } from "@/lib/api";
import { Icon } from "@/ui/icons";
import { Card } from "@/ui/kit";
import { PageHeader, SECONDARY } from "@/ui/Shell";

export default function More() {
  const nav = useNavigate();
  return (
    <>
      <PageHeader title="More" />
      <div className="grid gap-2">
        {SECONDARY.map((s) => (
          <Card key={s.to} onClick={() => nav(s.to)} className="flex items-center gap-3">
            <Icon name={s.icon} />
            <span className="flex-1 font-semibold">{s.label}</span>
            <Icon name="chevron" className="size-5 text-muted" />
          </Card>
        ))}
        <Card onClick={() => void signOut().then(() => nav("/login"))} className="flex items-center gap-3 text-muted">
          <Icon name="logout" />
          <span className="flex-1 font-semibold">Sign out</span>
        </Card>
      </div>
    </>
  );
}
